import {
  GET_USER_BOOKMARKS_ERROR,
  GET_INFO_SECTION_USER_BOOKMARKS_SUCCESS,
  GET_MENU_SERIES_USER_BOOKMARKS_SUCCESS,
  CLEAR_INFO_SECTION_USER_BOOKMARK,
  GET_INFO_SECTION_BOOKMARKS_INIT,
  GET_MENU_SERIES_BOOKMARKS_INIT,
} from '../actions/bookmarks/constants';
import {
  GET_CONTENT_INIT,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_ERROR,
  GET_CONTENT_SERIE_INIT,
  GET_CONTENT_SERIE_SUCCESS,
  GET_CONTENT_SERIE_ERROR,
  GET_CONTENT_PBI_INIT,
  GET_CONTENT_PBI_SUCCESS,
  GET_CONTENT_PBI_ERROR,
  CLEAR_VCARD_DATA,
  GET_SEEN_LAST,
  CLEAR_SEEN_LAST,
  GET_SEEN_LAST_INIT,
  CLEAR_CONTENT_PBI,
} from '../actions/content/constants';

import {
  LOAD_RECOMMENDATIONS_INIT,
  LOAD_RECOMMENDATIONS_SUCCESS,
  LOAD_RECOMMENDATIONS_ERROR,
} from '../actions/recommendations/constants';

import {
  ADD_FAVORITE_START,
  ADD_FAVORITE_SUCCESS,
  ADD_FAVORITE_ERROR,
  DELETE_FAVORITE_START,
  DELETE_FAVORITE_SUCCESS,
  DELETE_FAVORITE_ERROR,
  CLEAR_FAVORITE_ERROR,
  API_FAVORITED_INIT,
  API_FAVORITED_SUCCESS,
} from '../actions/favorite/constants';

const initialState = {
  content: {
    group: {},
    isLoading: false,
    error: null,
  },
  PBI: {
    infoPBI: {},
    isLoadingPBI: false,
    errorPBI: {},
  },
  serie: {
    errorInfoSerie: null,
    isLoadingInfoSerie: true,
    infoSerie: {},
  },
  bookmarks: {
    infoSection: { groups: [], isBookmarkLoading: false },
    menuSeries: { groups: [], currentSeasonId: '', isBookmarkLoading: false },
    error: null,
    isLoading: true,
  },
  recommendations: {
    isLoading: false,
    data: [],
    error: null,
  },
  favorite: {
    apiFavorited: null,
    add: {
      isLoading: null,
      data: null,
      error: false,
    },
    delete: {
      isLoading: null,
      data: null,
      error: false,
    },
  },
  seenLast: {
    isLoading: false,
    data: null,
    serieId: null,
  },
};

export default function vcardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONTENT_INIT:
      return {
        ...state,
        content: {
          group: state.content.group,
          error: null,
          isLoading: true,
        },
      };
    case GET_CONTENT_SUCCESS: {
      const { group } = action.response;
      return {
        ...state,
        content: {
          error: null,
          isLoading: false,
          group,
        },
      };
    }
    case GET_CONTENT_ERROR:
      return {
        ...state,
        content: {
          error: action.error,
          isLoading: true,
        },
      };
    case GET_CONTENT_SERIE_INIT:
      return {
        ...state,
        serie: {
          infoSerie: state.serie.infoSerie,
          isLoadingInfoSerie: true,
          errorInfoSerie: null,
        },
      };
    case GET_CONTENT_SERIE_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        serie: {
          isLoadingInfoSerie: false,
          infoSerie: response,
          errorInfoSerie: null,
        },
      };
    }
    case GET_CONTENT_SERIE_ERROR:
      return {
        ...state,
        serie: {
          infoSerie: state.serie.infoSerie,
          isLoadingInfoSerie: true,
          errorInfoSerie: action.error,
        },
      };
    case GET_CONTENT_PBI_INIT:
      return {
        ...state,
        PBI: {
          infoPBI: {},
          isLoadingPBI: true,
          errorPBI: null,
        },
      };
    case GET_CONTENT_PBI_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        PBI: {
          isLoadingPBI: false,
          infoPBI: response,
          errorPBI: null,
        },
      };
    }
    case GET_CONTENT_PBI_ERROR:
      return {
        ...state,
        PBI: {
          infoPBI: state.PBI.infoPBI,
          isLoadingPBI: true,
          errorPBI: action.error,
        },
      };
    case GET_INFO_SECTION_BOOKMARKS_INIT:
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          infoSection: {
            ...state.bookmarks.infoSection,
            isBookmarkLoading: true,
          },
          error: null,
          isLoading: true,
        },
      };
    case GET_MENU_SERIES_BOOKMARKS_INIT:
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          menuSeries: {
            ...state.bookmarks.infoSection,
            isBookmarkLoading: true,
          },
          error: null,
          isLoading: true,
        },
      };
    case GET_MENU_SERIES_USER_BOOKMARKS_SUCCESS: {
      const { groups, seasonId } = action;
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          error: null,
          isLoading: false,
          menuSeries: {
            groups: [...groups],
            currentSeasonId: seasonId,
            isBookmarkLoading: false,
          },
        },
      };
    }
    case GET_INFO_SECTION_USER_BOOKMARKS_SUCCESS: {
      const { groups } = action;
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          error: null,
          isLoading: false,
          infoSection: { groups: [...groups], isBookmarkLoading: false },
        },
      };
    }
    case CLEAR_INFO_SECTION_USER_BOOKMARK:
      return {
        ...state,
        bookmarks: {
          ...initialState.bookmarks,
        },
      };
    case GET_USER_BOOKMARKS_ERROR:
      return {
        ...state,
        bookmarks: {
          ...initialState.bookmarks,
          error: action.error,
          isLoading: true,
        },
      };
    case LOAD_RECOMMENDATIONS_INIT:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          loading: true,
          error: null,
        },
      };
    case LOAD_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          loading: false,
          error: null,
          data: action.payload,
        },
      };
    case LOAD_RECOMMENDATIONS_ERROR:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          loading: false,
          error: action.payload,
        },
      };
    case ADD_FAVORITE_START:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          add: {
            isLoading: true,
            data: null,
            error: false,
          },
        },
      };
    case ADD_FAVORITE_SUCCESS:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          add: {
            isLoading: false,
            data: action.payload,
            error: false,
          },
        },
      };
    case ADD_FAVORITE_ERROR:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          add: {
            isLoading: false,
            data: action.payload,
            error: true,
          },
        },
      };
    case DELETE_FAVORITE_START:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          delete: {
            isLoading: true,
            data: null,
            error: false,
          },
        },
      };
    case DELETE_FAVORITE_SUCCESS:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          delete: {
            isLoading: false,
            data: action.payload,
            error: false,
          },
        },
      };
    case DELETE_FAVORITE_ERROR:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          delete: {
            isLoading: false,
            data: action.payload,
            error: true,
          },
        },
      };
    case CLEAR_FAVORITE_ERROR:
      return {
        ...state,
        favorite: {
          ...initialState.favorite,
        },
      };
    case CLEAR_VCARD_DATA:
      return {
        ...initialState,
      };
    case CLEAR_CONTENT_PBI:
      return {
        ...state,
        PBI: {
          infoPBI: {},
          isLoadingPBI: false,
          errorPBI: {},
        },
      };
    case GET_SEEN_LAST_INIT:
      return {
        ...state,
        seenLast: {
          ...initialState.seenLast,
          isLoading: true,
        },
      };
    case GET_SEEN_LAST:
      return {
        ...state,
        seenLast: {
          isLoading: false,
          data: action.payload.seenLast,
          serieId: action.payload.serieId,
        },
      };
    case CLEAR_SEEN_LAST:
      return {
        ...state,
        seenLast: initialState.seenLast,
      };
    case API_FAVORITED_INIT:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          loadingApi: true,
        },
      };
    case API_FAVORITED_SUCCESS:
      return {
        ...state,
        favorite: {
          ...state.favorite,
          loadingApi: false,
        },
      };

    default:
      return state;
  }
}
